import React, { useState } from "react";

const WHATSAPP_ICON = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="#ffffff"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M20.52 3.48A11.86 11.86 0 0 0 12.04 0C5.5 0 .2 5.3.2 11.84c0 2.09.55 4.13 1.59 5.93L0 24l6.38-1.67a11.83 11.83 0 0 0 5.66 1.44h.01c6.54 0 11.84-5.3 11.84-11.84 0-3.16-1.23-6.13-3.37-8.45zM12.05 21.8h-.01a9.94 9.94 0 0 1-5.06-1.39l-.36-.21-3.78.99 1.01-3.69-.24-.38a9.93 9.93 0 0 1-1.52-5.28c0-5.48 4.46-9.94 9.97-9.94 2.66 0 5.16 1.04 7.04 2.92a9.88 9.88 0 0 1 2.92 7.04c0 5.49-4.47 9.94-9.97 9.94zm5.46-7.44c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.48-1.77-1.66-2.07-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.64-.93-2.24-.25-.59-.5-.51-.68-.52l-.58-.01c-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.5s1.08 2.9 1.23 3.1c.15.2 2.12 3.24 5.14 4.54.72.31 1.28.49 1.71.63.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35z" />
  </svg>
);

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href="https://wa.link/u8ucah"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatear por WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "fixed",
        bottom: "130px",
        right: "52px",
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        zIndex: 1040,
        transform: hovered ? "scale(1.08)" : "scale(1)",
        transition: "transform 0.2s ease",
      }}
    >
      {WHATSAPP_ICON}
    </a>
  );
};

export default WhatsAppButton;
